<template>
  <div v-if="total > 0" class="lc-pagination" :style="paginationStyle">
    <el-pagination
      v-if="total"
      :current-page.sync="currentPage"
      :page-sizes="pageSizes"
      :page-size.sync="pageSize"
      :small="smallSize"
      :layout="layouts"
      :total="total"
      @size-change="handleSizeChange"
      @current-change="handlePageChange"
    >
    </el-pagination>
  </div>
</template>

<script>
import Vue from 'vue'
import { ApiSearching } from '@/constants/bus_event'
import SearchMixin from '@/mixins/search'
import nativeMsgUtil from '@/utils/native_msg_util'

export default {
  mixins: [SearchMixin],
  props: {
    /**
     * 总页数
     * v-if="total" 是 this.currentPage 能渲染的关键
     * https://github.com/ElemeFE/element/issues/3188
     */
    total: {
      type: Number,
      default: 0
    },
    // 通讯总线，主要用于API查询通讯
    bus: {
      type: Vue,
      default: () => null
    }
  },
  data() {
    return {
      pageSizes: [20, 50, 100],
      currentPage: 1,
      pageSize: 20,
      layouts: 'total, sizes, prev, pager, next, jumper',
      smallSize: false,
      isUnderMobile: false
    }
  },
  computed: {
    /**
     * 菜单是否收起
     *
     * @returns {boolean} 是否收起
     */
    isMenuCollapse() {
      // 直接读取 state
      return this.$store.state.menu.isCollapse
    },
    /**
     * 分页组件的样式
     *
     * @returns {string} style 样式
     */
    paginationStyle() {
      let leftPix = 0
      if (this.isMenuCollapse) {
        // 如果是折叠菜单，移动端全收起，PC端保留小图标
        leftPix = this.isUnderMobile ? 0 : 64
      } else {
        // 如果展开菜单，移动端和PC端都展示完整的尺寸
        leftPix = 168
      }

      return `left: ${leftPix}px`
    }
  },
  created() {
    // Api 搜索启动后，响应（除了响应的方法，其他的基本已经不需要）
    if (this.bus) this.bus.$on(ApiSearching, this._apiSearchingProcess)

    // 如果是手机端下，则展示简约版
    if (nativeMsgUtil.isUnderMobile()) {
      this.isUnderMobile = true
      this.layouts = 'prev, pager, next'
      this.smallSize = true
    }
  },
  destroyed() {
    if (this.bus) this.bus.$off(ApiSearching, this._apiSearchingProcess)
  },
  methods: {
    // 每页数量变化响应
    handleSizeChange(size) {
      this.emitPageApi({ pageSize: size, page: 1 })
    },
    // 当前页变化后响应
    handlePageChange(page) {
      this.emitPageApi({ pageSize: this.pageSize, page: page })
    },
    // 请求API响应
    emitPageApi({ pageSize, page }) {
      // 请求 API 更新
      this.emitApiParamsChanged(
        this.bus,
        {
          page: page,
          per_page: pageSize
        },
        'LcPagination'
      )
    },
    /**
     * API 搜索的同步
     *
     * @param {object} search 查询参数
     * @param {object} search.pagination 分页信息
     *   格式：{page, perPage}
     */
    _apiSearchingProcess({ pagination }) {
      this.currentPage = pagination.page ? Number(pagination.page) : 1
      this.pageSize = pagination.perPage ? Number(pagination.perPage) : 20
    }
  }
}
</script>

<style lang="scss" scoped>
.lc-pagination {
  position: fixed;
  bottom: 0px;
  right: 18px;
  background-color: #ffffffdd;
  padding: 10px 0px;
  padding-left: 20px;
  border-top: 1px solid #eee;
  text-align: right;
  padding-right: 20px;
  z-index: 10;
  // transition: all 0.3s ease-in-out;
}
@media screen and (max-width: 600px) {
  .lc-pagination {
    position: absolute;
    right: 18px;
    bottom: 0;
  }
}
</style>
